export default __webpack_public_path__ + "static/media/cases-02.5b8ae200.jpg";